import { useShortcutsStore, useShortcutsActionsStore } from './context';

export const useShortcuts = () => useShortcutsStore();

export const useShortcutsActions = () => {
	const [, actions] = useShortcutsActionsStore();

	return [undefined, actions] as const;
};
